import type { HelpFile } from '../../types/help'
import { WizardStepLaunchTestIds } from '../../../testids/WizardStepLaunchTestIds'

export const wizardStepLaunchHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [WizardStepLaunchTestIds.launchSection]:
      'Optionen nach dem Speichern der Richtlinie: ohne Kampagne abschließen oder eine Kampagne vorbereiten — optional sofort aktivieren.',
    [WizardStepLaunchTestIds.launchSummary]:
      'Schreibgeschützte Zusammenfassung der soeben gespeicherten Richtlinie, bevor Sie das weitere Vorgehen wählen.',
    [WizardStepLaunchTestIds.btnLaunchStage]:
      'Erstellt sofort eine Kampagne im Status „Vorbereitung", verknüpft mit dieser Richtlinie und unten vorausgefüllt.',
    [WizardStepLaunchTestIds.btnLaunchStageActivate]:
      'Erstellt die Kampagne und löst sofort den Generierungsauftrag aus (Wechsel zu „Generierung ausstehend").',
    [WizardStepLaunchTestIds.btnFinish]:
      'Speichert nur die Richtlinie und kehrt zur Übersichtsseite zurück, ohne eine Kampagne vorzubereiten.',
    [WizardStepLaunchTestIds.btnLaunchBack]: null,
    [WizardStepLaunchTestIds.launchScopeCount]: null,
    [WizardStepLaunchTestIds.launchScopeDisclaimer]: null,
    [WizardStepLaunchTestIds.launchGoToCampaign]: null,
    [WizardStepLaunchTestIds.launchNoCampaignPermission]: null,
    [WizardStepLaunchTestIds.launchOpenCampaignWarning]: null,
    [WizardStepLaunchTestIds.launchPartialFailure]: null,
    [WizardStepLaunchTestIds.launchStageError]: null,
    [WizardStepLaunchTestIds.wizardLaunchAlreadySavedNote]: null,
    [WizardStepLaunchTestIds.wizardPolicySavedBanner]: null,
  },
}
